import validator from "validator";

export const isValidEmail = (email = "") => {
    const trimmed = email.trim();

    // basic email format check
    if (!validator.isEmail(trimmed)) return false;

    // extract domain
    const domain = trimmed.split("@")[1];
    const domainName = domain.split(".")[0];

    // reject numeric-only domains like 6799.com
    if (/^\d+$/.test(domainName)) return false;

    return true;
};